export function SiteForwardBadge() {
  return (
    <div className="fixed bottom-4 right-4 z-50 bg-white/95 backdrop-blur-sm border border-gray-200 rounded-lg shadow-lg p-3 text-sm">
      <div className="text-gray-600 mb-1">
        Modernized by{" "}
        <a
          href="https://siteforward.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          SiteForward.ai
        </a>
      </div>
      <a href="/modernization-report" className="text-blue-600 hover:text-blue-800 underline text-xs">
        View modernization report &raquo;
      </a>
    </div>
  );
}
